<app-basic-modal class="register-modal" [status]="modalStatus" [iconSrc]="'/assets/svg/no-registrado.svg'">
  <section class="error-login-modal">
    <h3 class="title">Lo sentimos, este correo no está registrado</h3>
    <p class="text" [innerHTML]="message"></p>
  </section>
  <app-button [buttonId] ="'register-modal'"
 [title]="'Registrarme'" (click)="openSignUpForm()"[customClasses]="'main w-75 py-3 m-2'" ></app-button>
 <app-button [buttonId] ="'register-modal'"
 [title]="'Cancelar'" (click)="Close()" [customClasses]="' google w-75 py-3 center-block m-2'"></app-button>

</app-basic-modal>


